import $ from 'jquery'
import _ from 'lodash'

import { AddressSearch } from '../address-search/address-search'
import { Geofence } from '../geofence/geofence'
import { NotificationsModel } from './notifications-model'
import { NotificationsValidation } from './notifications-validation'

class NotificationsModal {
  constructor() {
    this.addressSearch = new AddressSearch()
    this.geofence = new Geofence('geofence-map')
    this.model = new NotificationsModel()
    this.validation = new NotificationsValidation()
  }

  /**
   * Register the handler for the click the save button event.
   */
  listenToSave() {
    $('#ID_BTN_SAVE_NOTIFICATIONS').on('click', this.onSave.bind(this))
  }

  /**
   * Register the handler for the modal opening event.
   */
  listenToOpen() {
    $('#ID_BTN_NOTIFICATIONS').on('click', this.onOpen.bind(this))
  }

  /**
   * Register the handler for the select/deselect all event.
   */
  listenToToggleSelectAll() {
    $('#notify_select_all').on('change', this.onToggleSelectAll.bind(this))
  }

  /**
   * Register the handler for input changes.
   */
  listenToChange() {
    $('#ID_NOTIFICATIONS_MODAL input').on('change', this.onChange.bind(this))
  }

  /**
   * Register the handler for debouncing key presses.
   */
  listenToDebouncedKeyup() {
    $('#ID_NOTIFICATIONS_MODAL input').on(
      'keyup',
      _.debounce(this.onChange.bind(this), 500)
    )
  }

  /**
   * Register the handler for fixing map size when the modal is shown.
   */
   listenToModalShown() {
     $('#ID_NOTIFICATIONS_MODAL').on(
       'shown.bs.modal',
       this.onModalShown.bind(this)
     )
   }

   /**
    * Register the handler for cleaning up the map when modal is hidden.
    */
   listenToModalHidden() {
     $('#ID_NOTIFICATIONS_MODAL').on(
       'hidden.bs.modal',
       this.onModalHidden.bind(this)
     )
   }

   /**
    * Register the handler for the address search bar.
    */
   listenToAddressSearch() {
     // const twoSeconds = 2000
     // $('input[name="geofence_address_search"]').on(
     //   'keyup',
     //   _.debounce(this.onAddressSearch.bind(this), twoSeconds)
     // )
     $('#geofence_search_button').on('click', this.onAddressSearch.bind(this))
   }

   /**
    * Handle typing into the address search bar events.
    */
   async onAddressSearch() {
     const address = $('input[name="geofence_address_search"]').val()
     $('#geofence_search_button').prop('disabled', true)
     $('#geofence_search_button i').addClass('d-none')
     $('#geofence_search_button span').removeClass('d-none')
     try {
       const location = await this.addressSearch.locate(address)
       this.geofence.centerBoundedMap(location.center, location.bounds)
     }
     catch (e) {
       // No results
     }
     finally {
       $('#geofence_search_button').prop('disabled', false)
       $('#geofence_search_button i').removeClass('d-none')
       $('#geofence_search_button span').addClass('d-none')
     }
   }

  /**
   * Initialize the module.
   */
  onLoad() {
    this.listenToAddressSearch()
    this.listenToChange()
    this.listenToDebouncedKeyup()
    this.listenToModalShown()
    this.listenToModalHidden()
    this.listenToOpen()
    this.listenToSave()
    this.listenToToggleSelectAll()
  }

  /**
   * Handle the modal opening event.
   */
  onOpen() {
    this.clearErrors()
    window.CfgManager.rememberSelectedRows()
    const config = window.CfgManager.getSelectedTagConfig()
    const notifications = config.hasOwnProperty('notifications') ?
      config.notifications : []
    this.repopulateForm(notifications)
    this.geofence.initializeMap()
    this.onChange()
  }

  /**
   * Handle the click the save button event.
   */
  onSave(event) {
    $('#ID_BTN_SAVE_NOTIFICATIONS').prop('disabled', true)
    this.clearErrors()
    this.model.pull()
    // console.log('model', this.model.toObject())
    this.validation.validateForm(this.model)
    // console.log(this.validation.errors, this.validation.valid)
    this.model.push()
    if ( ! this.validation.valid) {
      $('#ID_BTN_SAVE_NOTIFICATIONS').prop('disabled', false)
      event.preventDefault()
      this.showErrors()
    }
    else {
      const settings = this.model.toObject().config
      window.CfgManager.notificationSettings = settings
      // window.CfgManager.recipientSettings = recipientData
      window.CfgManager.updateConfig('set_notifications')
    }
  }

  /**
   * Handle the select/deselect all event.
   */
  onToggleSelectAll(event) {
    this.model.toggleSelectAll()
    this.onChange()
  }

  /**
   * Handle input change events.
   */
  onChange(event) {
    this.model.pull()
    this.updateSaveButton()
    this.highlightMissingFields()
    this.updateGeofenceUsable()
  }

  /**
   * Handle modal shown events.
   */
  onModalShown() {
    if (this.geofence.map !== null) {
      // Fix map sizing
      this.geofence.map.invalidateSize()
      // Redraw geofence
      this.geofence.drawing.drawFence()
      // Fit the map to the geofence
      this.geofence.drawing.fitFence(false)
      // Disable or enable the map depending on if geofence is enabled
      this.updateGeofenceUsable()
    }
  }

  /**
   * Handle modal hidden events.
   */
  onModalHidden() {
    this.geofence.clearMap()
  }

  /**
   * Enable or disable the save button depending on the validity of the form.
   */
  updateSaveButton() {
    const canSave = this.validation.canSave(this.model)
    $('#ID_BTN_SAVE_NOTIFICATIONS').prop('disabled', ! canSave)
  }

  /**
   * Highlight fields that need to be filled out before submitting changes.
   */
  highlightMissingFields() {
    const hasNotifications = this.model.hasNotifications()
    for (const type in this.model.types) {
      const input = this.model.types[type]
      const id = input.id
      const notification = input.notification
      const inputs = input.inputs
      const enabled = this.model.configs[type].enabled || ! this.model.types[type].notification
      const contactable = this.model.hasRecipients()
      let highlightNotification = false
      let highlightRecipient = false
      for (let i = 0; i < inputs.length; i++) {
        const $input = $(`input[name="${inputs[i]}"]`)
        const empty = $input.val() === ''
        highlightNotification = enabled && empty
        highlightRecipient = hasNotifications && ! contactable
        if (highlightNotification && notification) {
          $input.addClass('required')
        }
        else if (highlightRecipient && ! notification) {
          $input.addClass('required')
        }
        else {
          $input.removeClass('required')
        }
      }
    }
  }

  /**
   * Load the model from the config and push to the form.
   */
  repopulateForm(config) {
    $('input[name="notify_select_all"').prop('checked', false)
    this.model.load(config)
    this.model.push()
  }

  /**
   * Enable or disable the map depending on the geofence notification status.
   */
  updateGeofenceUsable() {
    const enabled = this.model.configs['geofence'].enabled
    enabled ? this.geofence.enable() : this.geofence.disable()
    $('input[name="geofence_address_search"]').prop('disabled', ! enabled)
    $('#geofence_search_button').prop('disabled', ! enabled)
  }

  /**
   * Remove any error messages displayed on the form.
   */
  clearErrors() {
    const $errors = $('#ID_NOTIFICATIONS_MODAL .error-messages')
    $errors.slideUp('slow')
    $errors.html('')
  }

  /**
   * Display the error messages on the form.
   */
  showErrors() {
    const $errors = $('#ID_NOTIFICATIONS_MODAL .error-messages')
    let errorsHtml = ''
    for (const id in this.validation.errors) {
      const errorMessage = this.validation.errors[id]
      errorsHtml += `<div class="alert alert-danger" role="alert">${errorMessage}</div>`
    }
    $errors.html(errorsHtml)
    $errors.slideDown('slow')
  }
}

export { NotificationsModal }
